import axios from "axios";
import { Toast } from "../../util/Toast";

import { GET_SELLER, SET_ADMIN, UNSET_ADMIN, UPDATE_PROFILE } from "./types";
import { key } from "../../util/Config";

/** Drop any stale Agency profile / host caches so lifetime coins cannot paint again. */
export const clearAgencyClientCaches = (agencyId) => {
  try {
    const keys = Object.keys(sessionStorage);
    keys.forEach((k) => {
      if (
        k.startsWith("agency_profile_cache_") ||
        k.startsWith("agency_hosts_cache_")
      ) {
        sessionStorage.removeItem(k);
      }
    });
    if (agencyId) {
      sessionStorage.removeItem(`agency_profile_cache_${agencyId}`);
    }
  } catch {
    /* ignore */
  }
};

export const login = (data) => (dispatch) => {
  clearAgencyClientCaches();
  axios
    .post(`agency/login?key=${key}`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "You have successfully logged in Ⴆσσɱҽɾ Lιʋҽ.");
        setTimeout(() => {
          window.location.href = "/agencyPanel/dashboard";
        }, 100);
        dispatch({ type: SET_ADMIN, payload: res.data.token });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

export const getProfile = (agencyId) => (dispatch) => {
  if (!agencyId) return;

  // Never hydrate from sessionStorage — PO still saw old Available Coin from stale cache.
  clearAgencyClientCaches(agencyId);

  axios
    .get(`agency/getAgencyProfile?agencyId=${agencyId}&_=${Date.now()}`)
    .then((res) => {
      if (res.data.status) {
        const data = res.data?.data || {};
        const week = data.weekly?.agencyThisWeek;
        // STRICT: current week only. Missing week record → ZERO (never lifetime fields).
        const weekCoins = Number(week?.eligibleCoins ?? 0) || 0;
        const weekSalary = Number(week?.salaryUsd ?? data.salaryDollar ?? 0) || 0;
        const weekLevel = Number(week?.level ?? data.salaryLevel ?? 0) || 0;
        const merged = {
          ...data,
          currentHostCoin: weekCoins,
          salaryDollar: weekSalary,
          salaryLevel: weekLevel,
          rCoin: weekCoins,
          totalCoin: weekCoins,
          currentCoin: 0,
          weekId: data.weekId || data.weekly?.weekId || null,
          withdrawableUsd:
            data.withdrawableUsd != null
              ? Number(data.withdrawableUsd)
              : Number(data.appSalaryDollar) || 0,
        };
        dispatch({ type: GET_SELLER, payload: merged });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
    });
};

export const changePassword = (data) => (dispatch) => {
  axios
    .put("admin", data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Password changed successfully.");
        setTimeout(() => {
          dispatch({ type: UNSET_ADMIN });
          window.location.href = "/agencyPanel";
        }, [3000]);
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const updateProfile = (agency_id, data) => (dispatch) => {
  axios
    .patch(`agency/profile/${agency_id}`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Profile updated successfully.");
        dispatch({ type: UPDATE_PROFILE, payload: res.data?.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
